import { render } from "./CommentsView.vue?vue&type=template&id=47c3a4ba&scoped=true"
import script from "./CommentsView.vue?vue&type=script&lang=js"
export * from "./CommentsView.vue?vue&type=script&lang=js"

import "./CommentsView.vue?vue&type=style&index=0&id=47c3a4ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c3a4ba"]])

export default __exports__